export const initializeUtiqNamespace = () => {
  window.Utiq = window.Utiq || {};
  const { Utiq } = window;
  Utiq.functions = Utiq.functions || {};
  Utiq.config = Utiq.config || {};
  Utiq.isInitialPageLoad = true;

  return Utiq;
};
